<template>
    <div id="yield">
        <div class="row">
            <div class="col-sm-12 col-md-11 col-lg-11">
                <div class="section-heading heading-left">
                    <span class="subtitle primary bold">Desempeño.</span>
                    <div class="row">
                        <div class="col-lg-12 mb--20">
                            <h2 class="font-weight-100">
                                En los últimos 3 años, el portafolio global
                                ha generado rendimientos promedio de <span class="bold">{{ getAverageYield }}</span> anual.
                            </h2>
                        </div>
                        <div v-if="isMounted" class="col-12 mb--20">
                            <div class="row">
                                <div class="col-sm-12 col-md-10 col-lg-10">
                                    <div id="chart">
                                        <VueApexCharts v-if="isGraphReady" type="line" height="350" :options="chartOptions" :series="series">
                                        </VueApexCharts>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isMounted" class="col-12">
                            <!-- TABLA TEST -->
                            <div class="table-responsive">
                                <table class="table rg-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(column, index) in columns" scope="col"
                                                :class="column.bold ? 'bold' : 'normal'">{{ column.title }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, index) in data">
                                            <th>{{ tr.item1 }}</th>
                                            <template v-if="index == data.length - 1">
                                                <td>{{ decimalPercentFormat(tr.item9) }}</td>
                                                <td>{{ decimalPercentFormat(tr.item8) }}</td>
                                                <td>{{ decimalPercentFormat(tr.item7) }}</td>
                                                <td>{{ decimalPercentFormat(tr.item6) }}</td>
                                                <td>{{ decimalPercentFormat(tr.item5) }}</td>
                                                <td>{{ decimalPercentFormat(tr.item4) }}</td>
                                            </template>
                                            <template v-else>
                                                <td>{{ explicitMoneyFormat(tr.item9, 0) }}</td>
                                                <td>{{ explicitMoneyFormat(tr.item8, 0) }}</td>
                                                <td>{{ explicitMoneyFormat(tr.item7, 0) }}</td>
                                                <td>{{ explicitMoneyFormat(tr.item6, 0) }}</td>
                                                <td>{{ explicitMoneyFormat(tr.item5, 0) }}</td>
                                                <td>{{ explicitMoneyFormat(tr.item4, 0) }}</td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                                <div>
                                    <small><i>* datos contemplados al cierre de mes.</i></small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper.js";
import VueApexCharts from 'vue-apexcharts'

const columns = [
    { title: "Desempeño", bold: true },
    { title: "2025*", bold: false },
    { title: "2024", bold: false },
    { title: "2023", bold: false },
    { title: "2022", bold: false },
    { title: "2021", bold: false },
    { title: "2020", bold: false },
]
const data = [
    {
        item1: "Activos bajo administración",
        item2: 0,
        item3: 0,
        item4: 0,
        item5: 0,
        item6: 0,
        item7: 0,
        item8: 0,
    },
    {
        item1: "Intereses",
        item2: 0,
        item3: 0,
        item4: 0,
        item5: 0,
        item6: 0,
        item7: 0,
        item8: 0,
    },
    {
        item1: "Rendimiento",
        item2: 0,
        item3: 0,
        item4: 0,
        item5: 0,
        item6: 0,
        item7: 0,
        item8: 0,
    }
]

export default {
    name: "Yield",
    props: ["rgStats", "isMounted"],
    mixins: [
        formatHelper
    ],
    components: {
        VueApexCharts
    },
    data: () => ({
        columns: columns,
        data: data,
        publicSiteYield: null,
        isGraphReady: false,
        maxValue: 0,
        series: [
            {
                name: 'Activos bajo administración',
                type: 'line',
                data: [0, 0, 0, 0, 0, 0]
            },
            {
                name: 'Rendimiento',
                type: 'line',
                data: [0, 0, 0, 0, 0, 0]
            },
        ],
        chartOptions: {
            chart: {
                height: 350,
                type: 'line',
                stacked: false,
                toolbar: {
                    show: false
                },
                tooltip: {
                    enabled: false
                },
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
            },
            grid: {
                show: true,
                borderColor: '#999FAE',
                strokeDashArray: 15,
                position: 'back',
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                },
                row: {
                    colors: undefined,
                    opacity: 0.5
                },
                column: {
                    colors: undefined,
                    opacity: 0.5
                },
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
            },
            colors: ["#28DE18", "#CBFF00"],
            dataLabels: {
                enabled: true,
                offsetX: 0,
                offsetY: 0,
                textAnchor: 'middle',
                distributed: false,
                // style: {
                //     fontSize: '12px',
                //     fontWeight: 'bold',
                // },
                background: {
                    enabled: true,
                    foreColor: '#000',
                    opacity: 0.9,
                    borderWidth: 1,
                    borderColor: '#fff'
                },
                formatter: function (val) {
                    if (val < 20) {
                        return val + "%";
                    } else {
                        let value = (val / 1000000).toFixed(0).replace(",", ".");
                        let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if (money == null) return "";
                        else {
                            return money + "M";
                        }
                    }
                }
            },
            markers: {
                size: 1,
            },
            // stroke: {
            //     width: [1, 1, 4]
            // },
            xaxis: {
                categories: [2019, 2020, 2021, 2022, 2023, 2024, 2025],
            },
            yaxis: [
                {
                    axisTicks: {
                        show: true,
                    },
                    axisBorder: {
                        show: true,
                        color: '#3B3A3E'
                    },
                    min: 10000000,
                    max: 25000000,
                    labels: {
                        style: {
                            colors: '#3B3A3E',
                        },
                        floating: true,
                        formatter: function (val) {
                            let value = (val / 1).toFixed(0).replace(",", ".");
                            let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            if (money == null) return "";
                            else {
                                return "$" + money
                            }
                        }
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                {
                    seriesName: 'Rendimiento',
                    opposite: true,
                    axisTicks: {
                        show: true,
                    },
                    axisBorder: {
                        show: true,
                        color: '#3B3A3E'
                    },
                    min: 0,
                    max: 20,
                    labels: {
                        style: {
                            colors: '#3B3A3E',
                        },
                        formatter: function (val) {
                            return val.toFixed(0) + "%"
                        }
                    },
                },
            ],
            tooltip: {
                enabled: false
            },
            legend: {
                horizontalAlign: 'right',
                offsetX: 40
            }
        },
    }),
    computed: {
        getAverageYield()
        {
            const netYieldArray = this.data[2];
            const average = netYieldArray.item7 + netYieldArray.item6 + netYieldArray.item5;

            return `${((average / 3) * 100).toFixed(2)}%`;
        },
    },
    mounted() {
        this.getStats();
    },
    methods: {
        getStats() {
            if(this.isMounted){
                const rg_stats = this.rgStats;
                this.publicSiteYield = JSON.parse(rg_stats.public_site_yield);
                let index = 2;
                let chartIndex = 0;
                this.chartOptions.xaxis.categories = [];
                this.publicSiteYield.performance.forEach(item => {
                    this.data[0][`item${index}`] = item.max;
                    this.data[1][`item${index}`] = item.sum;
                    this.data[2][`item${index}`] = item.avg;
                    
                    this.series[0].data[chartIndex] = item.max;
                    this.series[1].data[chartIndex] = (item.avg * 100).toFixed(2);
                    this.chartOptions.xaxis.categories.push(item.balance_date.slice(0,4));

                    this.maxValue = item.max;

                    index++;
                    chartIndex++;

                });
                const maxValue =  Math.round(this.maxValue / 100000) * 100000;
                
                this.chartOptions.yaxis[0].max = maxValue + 10000000;
                this.isGraphReady = true;
            }
        }
    }
}
</script>